// src/mocks/handlers/dashboard/sourceExposure.ts

import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ISourceExposureResponse } from '@/domains/dashboard/sourceExposure/sourceExposure.type';
import sourceExposureData from '@/mocks/data/dashboard_sourceExposure.json';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';
import { format, subDays } from 'date-fns';

export const sourceExposureHandler = rest.get<
  ISourceExposureResponse,
  { customer_uuid: string }
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.DASHBOARD_SOURCE_EXPOSURE}`,
  (req, res, ctx) => {
    const { customer_uuid } = req.params;
    const currency = req.url.searchParams.get('currency');

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    // Filter the data based on the customer_uuid
    const customerData = sourceExposureData.find(
      (entry) => entry.uuid === customer_uuid,
    );

    if (!customerData) {
      return res(ctx.status(404), ctx.json({ error: 'Customer not found' }));
    }

    const resultEntry = customerData.results.find((r) =>
      currency && currency !== ''
        ? r.currency === currency
        : r.currency === null,
    );

    if (!resultEntry) {
      return res(
        ctx.status(404),
        ctx.json({ error: 'No source exposure data found' }),
      );
    }

    const today = new Date();
    const updated_at = `${format(subDays(today, 5), 'yyyy-MM-dd')}`;

    const response: ISourceExposureResponse = {
      aggregated_exposure: resultEntry.aggregated_exposure,
      breakdown: resultEntry.breakdown,
      updated_at: resultEntry.updated_at || updated_at,
    };

    return res(ctx.status(200), ctx.json(response));
  },
);
